var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"import-offices-controls"},[_c('import-offices-button'),_vm._v(" "),_c('import-offices-modal',{attrs:{"should-close":_vm.shouldClose}},[_c('file-import-control',{attrs:{"action-name":"createOfficesFromFile"},on:{"import-complete":_vm.notifyToClose}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }